// extracted by mini-css-extract-plugin
module.exports = {"main":"home_main__288UO","menu":"home_menu__LVF14"};